document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-comparison-table").forEach((sectionEl) => {
    // Toggle: works with any number of tabs present.
    // A button with data-category="X" controls the panel with id="comparison-X".
    // Works for the inline tabs (reproductive/proactive/bundle) and the
    // metaobject tabs (table-0/table-1/...), with no hardcoded category list.
    const toggleButtons = Array.from(sectionEl.querySelectorAll(".toggle-btn"));
    const panelFor = (cat) => (cat ? sectionEl.querySelector("#comparison-" + cat) : null);

    // Per-tab heading/subheading: each toggle button carries the active table entry's
    // heading/subheading, so the section heading swaps when you switch category. (Buttons
    // without these data attrs — e.g. the legacy inline toggle — leave the heading alone.)
    const headingEl = sectionEl.querySelector(".comparison-main-heading");
    const subEl = sectionEl.querySelector(".comparison-subheading");
    const syncHeading = (btn) => {
      if (!btn) return;
      if (headingEl && typeof btn.dataset.heading === "string") headingEl.textContent = btn.dataset.heading;
      if (subEl && typeof btn.dataset.subheading === "string") subEl.textContent = btn.dataset.subheading;
    };

    if (toggleButtons.length) {
      // Ensure only one is visible initially (Liquid sets initial display, but we normalize)
      const activeBtn = toggleButtons.find((b) => b.classList.contains("active")) || toggleButtons[0];
      toggleButtons.forEach((b) => b.classList.remove("active"));
      if (activeBtn) activeBtn.classList.add("active");

      const showCategory = (target) => {
        toggleButtons.forEach((b) => {
          const panel = panelFor(b.dataset.category);
          if (panel) panel.style.display = b.dataset.category === target ? "block" : "none";
        });
      };

      showCategory(activeBtn ? activeBtn.dataset.category : null);
      syncHeading(activeBtn);

      toggleButtons.forEach((btn) =>
        btn.addEventListener("click", function () {
          toggleButtons.forEach((b) => b.classList.remove("active"));
          this.classList.add("active");
          showCategory(this.dataset.category);
          syncHeading(this);
        })
      );
    }

    // Floating compact header bar.
    // Decoupled from the table so it doesn't shift the document when shown.
    // Mirrors title + price + Buy button for the visible tab's products, and
    // appears only while the user has scrolled past the table's real header
    // but the table is still in view.
    const bar = document.createElement("div");
    bar.className = "comparison-sticky-bar";
    bar.setAttribute("hidden", "");
    sectionEl.appendChild(bar);

    function visibleTab() {
      return Array.from(
        sectionEl.querySelectorAll(".comparison-content, .four-comparison-content")
      ).find((el) => el.offsetParent !== null);
    }

    function populateBar() {
      const tab = visibleTab();
      if (!tab) {
        bar.innerHTML = "";
        return;
      }
      const headers = tab.querySelectorAll("th.product-header-col");
      let html =
        '<div class="comparison-sticky-bar-aligner">' +
        '<div class="comparison-sticky-bar-row">' +
        '<div class="comparison-sticky-bar-spacer"><div class="comparison-sticky-bar-title">Test:</div></div>';
      headers.forEach((th) => {
        const header = th.querySelector(".product-header");
        if (!header) {
          html += '<div class="comparison-sticky-bar-col"></div>';
          return;
        }
        const titleEl = header.querySelector(".product-title");
        const priceEl = header.querySelector(".product-price");
        const btnEl = header.querySelector(".btn");
        const titleHtml = titleEl ? `<div class="comparison-sticky-bar-title">${titleEl.innerHTML}</div>` : "";
        const priceHtml = priceEl ? `<span class="comparison-sticky-bar-price">${priceEl.innerHTML}</span>` : "";
        const btnHtml = btnEl
          ? `<a class="btn comparison-sticky-bar-btn" href="${btnEl.getAttribute("href") || "#"}">${btnEl.textContent.trim()}</a>`
          : "";
        const metaHtml =
          priceHtml || btnHtml
            ? `<div class="comparison-sticky-bar-meta">${priceHtml}${btnHtml}</div>`
            : "";
        html += `<div class="comparison-sticky-bar-col">${titleHtml}${metaHtml}</div>`;
      });
      html += "</div></div>";
      bar.innerHTML = html;
      attachScrollSync();
      syncBarLayout();
    }

    // Position the bar's aligner over the visible table-wrapper and size each
    // column to match the real table. The aligner has its own overflow-x:auto
    // so on mobile the bar scrolls horizontally; the sticky "What's included"
    // label stays pinned at left.
    function syncBarLayout() {
      const tab = visibleTab();
      if (!tab) return;
      const tableWrapper = tab.querySelector(".table-wrapper");
      const table = tab.querySelector("table");
      const aligner = bar.querySelector(".comparison-sticky-bar-aligner");
      const row = bar.querySelector(".comparison-sticky-bar-row");
      if (!tableWrapper || !table || !aligner || !row) return;

      const wrapperRect = tableWrapper.getBoundingClientRect();
      aligner.style.marginLeft = `${Math.max(0, wrapperRect.left)}px`;
      aligner.style.width = `${wrapperRect.width}px`;
      row.style.width = `${table.offsetWidth}px`;

      const featureLabel = tab.querySelector("th.table-feature-label");
      const productHeaders = tab.querySelectorAll("th.product-header-col");
      const spacer = bar.querySelector(".comparison-sticky-bar-spacer");
      const cols = bar.querySelectorAll(".comparison-sticky-bar-col");

      if (spacer && featureLabel) {
        spacer.style.flex = `0 0 ${featureLabel.getBoundingClientRect().width}px`;
      }
      productHeaders.forEach((th, i) => {
        if (cols[i]) {
          cols[i].style.flex = `0 0 ${th.getBoundingClientRect().width}px`;
        }
      });

      // Initial horizontal sync with the table-wrapper
      aligner.scrollLeft = tableWrapper.scrollLeft;
    }

    // Keep the bar's horizontal scroll in sync with the table's. Bidirectional
    // so dragging either one moves the other.
    let syncingScroll = false;
    function attachScrollSync() {
      const aligner = bar.querySelector(".comparison-sticky-bar-aligner");
      if (!aligner || aligner.dataset.syncBound) return;
      aligner.dataset.syncBound = "1";

      aligner.addEventListener(
        "scroll",
        () => {
          if (syncingScroll) return;
          const tab = visibleTab();
          const wrapper = tab && tab.querySelector(".table-wrapper");
          if (!wrapper) return;
          syncingScroll = true;
          wrapper.scrollLeft = aligner.scrollLeft;
          requestAnimationFrame(() => (syncingScroll = false));
        },
        { passive: true }
      );

      sectionEl.querySelectorAll(".table-wrapper").forEach((wrapper) => {
        if (wrapper.dataset.syncBound) return;
        wrapper.dataset.syncBound = "1";
        wrapper.addEventListener(
          "scroll",
          () => {
            if (syncingScroll) return;
            const tab = visibleTab();
            if (!tab || !tab.contains(wrapper)) return;
            syncingScroll = true;
            aligner.scrollLeft = wrapper.scrollLeft;
            requestAnimationFrame(() => (syncingScroll = false));
          },
          { passive: true }
        );
      });
    }

    function updateBar() {
      const tab = visibleTab();
      if (!tab) {
        bar.setAttribute("hidden", "");
        return;
      }
      const thead = tab.querySelector("thead");
      const table = tab.querySelector("table");
      if (!thead || !table) {
        bar.setAttribute("hidden", "");
        return;
      }
      const headerOffset =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue("--header-height")
        ) || 0;
      const theadRect = thead.getBoundingClientRect();
      const tableRect = table.getBoundingClientRect();
      const barHeight = bar.offsetHeight || 60;
      // Show only when the real header is above where the bar sits AND the
      // table bottom is still below the bar's bottom (so it disappears as
      // you scroll past the table). Account for the site nav offset so the
      // bar appears at the correct moment when the page has a sticky header.
      if (
        theadRect.bottom < headerOffset &&
        tableRect.bottom > headerOffset + barHeight
      ) {
        syncBarLayout();
        bar.removeAttribute("hidden");
      } else {
        bar.setAttribute("hidden", "");
      }
    }

    populateBar();
    updateBar();

    let scrollTicking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (!scrollTicking) {
          requestAnimationFrame(() => {
            updateBar();
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      },
      { passive: true }
    );

    // Coalesce layout recalculation requests so we don't thrash during bursts
    // of resize/scroll/observer events.
    let layoutTicking = false;
    function scheduleLayoutSync() {
      if (layoutTicking) return;
      layoutTicking = true;
      requestAnimationFrame(() => {
        syncBarLayout();
        updateBar();
        layoutTicking = false;
      });
    }

    window.addEventListener("resize", scheduleLayoutSync);
    // Mobile rotation: some browsers don't fire `resize` reliably here, but
    // do fire `orientationchange` slightly before layout settles. Delay so
    // we measure after the browser finishes reflowing.
    window.addEventListener("orientationchange", () => {
      setTimeout(scheduleLayoutSync, 50);
    });

    // iOS Safari URL-bar collapse/expand changes the visual viewport without
    // firing a normal resize. visualViewport gives us a signal for that.
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleLayoutSync);
      window.visualViewport.addEventListener("scroll", scheduleLayoutSync);
    }

    // ResizeObserver catches table-width changes from font loading, image
    // decoding, or content tweaks that wouldn't fire a window resize.
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(() => scheduleLayoutSync());
      sectionEl.querySelectorAll("table.table-class").forEach((t) => ro.observe(t));
    }

    // Repopulate when the user switches tabs
    sectionEl.querySelectorAll(".toggle-btn").forEach((btn) =>
      btn.addEventListener("click", () => {
        requestAnimationFrame(() => {
          populateBar();
          updateBar();
        });
      })
    );

    // Tooltip modal (scoped)
    const modal = sectionEl.querySelector("#tooltip-modal");
    const content = modal ? modal.querySelector(".tooltip-content") : null;
    const closeBtn = modal ? modal.querySelector(".tooltip-close") : null;

    if (modal && content && closeBtn) {
      sectionEl.addEventListener("click", function (e) {
        const trigger = e.target.closest(".tooltip-trigger");
        if (!trigger) return;

        e.preventDefault();
        const tooltipText = trigger.getAttribute("data-tooltip") || "";
        content.textContent = tooltipText;

        modal.classList.remove("hidden");

        const rect = trigger.getBoundingClientRect();
        const modalWidth = 200;
        const host = modal.offsetParent;
        const hostRect = host ? host.getBoundingClientRect() : null;
        const originTop = hostRect ? hostRect.top + host.clientTop : -window.scrollY;
        const originLeft = hostRect ? hostRect.left + host.clientLeft : -window.scrollX;

        modal.style.top = `${rect.bottom - originTop + 8}px`;
        modal.style.left = `${rect.left + rect.width / 2 - modalWidth / 2 - originLeft}px`;
      });

      closeBtn.addEventListener("click", function () {
        modal.classList.add("hidden");
      });

      // Close when clicking anywhere outside the tooltip frame (as well as the × button).
      document.addEventListener("click", function (e) {
        if (modal.classList.contains("hidden")) return;   // already closed
        if (modal.contains(e.target)) return;             // click inside the tooltip → keep open
        if (e.target.closest(".tooltip-trigger")) return; // a trigger click opens/switches tooltips
        modal.classList.add("hidden");
      });

      // Also close on Escape.
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") modal.classList.add("hidden");
      });
    }
  });
});